// React
import React, { useContext, useEffect } from "react";

import { Box, Divider, IconButton } from "@mui/material";

import Drawer from "@mui/material/Drawer";

import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import { DrawerHeaderRight } from "./Appbar";
import { useLocation } from "react-router-dom";
import { GlobalContext } from "../../../GlobalContext";

export const Right = ({ title, component }) => {
	const { openRight, handlerSideRight } = useContext(GlobalContext);
	const location = useLocation();

	// Vigila el pathname y, si no es '/review', cierra la barra.
	useEffect(() => {
		if (location.pathname !== "/review") {
			handlerSideRight(false, location.pathname.replace("/", ""));
		}
	}, [location.pathname, handlerSideRight]);

	return (
		<>
			<Drawer
				open={openRight}
				sx={{
					overflow: "hidden",
					width: 430,
					flexShrink: 0,
					"& .MuiDrawer-paper": {
						width: 430,
					},
				}}
				variant="persistent"
				anchor="right"
			>
				<DrawerHeaderRight>
					<IconButton onClick={() => handlerSideRight(false, location.pathname.replace("/", ""))}>
						{openRight ? <ChevronLeftIcon /> : <ChevronRightIcon />}
					</IconButton>
					<h4 style={{ position: "absolute", left: 50 }}>{title}</h4>
				</DrawerHeaderRight>

				<Divider />

				<Box sx={{ p: 2 }}>{component}</Box>
			</Drawer>
		</>
	);
};
